import { lumiApi } from "../index";

export const projectsApi = lumiApi.injectEndpoints({
    endpoints: (build) => ({
        getVolumeBreakdowns: build.mutation({
            query: ({
                        id,
                        concept_selector,
                        filter = null,
                        breakdowns = [],
                    }) => {
                const body = { concept_selector, filter, breakdowns };

                return {
                    url: `/projects/${id}/concepts/match_counts`,
                    method: "POST",
                    body,
                };
            },
            transformResponse(data) {
                return data;
            },
        }),
    }),
});

export const {
    useGetVolumeBreakdownsMutation
} = projectsApi;
